import createIcon from '../../createIcon';

/**
 * @component @name Games
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgNy41VjJIOVY3LjVMMTIgMTAuNUwxNSA3LjVaTTcuNSA5SDJWMTVINy41TDEwLjUgMTJMNy41IDlaTTkgMTYuNVYyMkgxNVYxNi41TDEyIDEzLjVMOSAxNi41Wk0xNi41IDlMMTMuNSAxMkwxNi41IDE1SDIyVjlIMTYuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Games = createIcon('Games', [
  [
    'path',
    {
      d: 'M15 7.5V2H9V7.5L12 10.5L15 7.5ZM7.5 9H2V15H7.5L10.5 12L7.5 9ZM9 16.5V22H15V16.5L12 13.5L9 16.5ZM16.5 9L13.5 12L16.5 15H22V9H16.5Z',
      key: '15tplo',
    },
  ],
]);

export default Games;
